import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import Cookies from 'js-cookie';
import { getBaseDomain } from '../../utils/domain';

interface CompanySwitchData {
  user_id: number;
  old_company_id: number;
  new_company_id: number;
  old_company_name: string;
  new_company_name: string;
  message: string;
  user_name: string;
  timestamp: string;
}

interface Props {
  isVisible: boolean;
  switchData: CompanySwitchData;
  tabId: string;
}

const EnhancedTenantSwitchModal: React.FC<Props> = ({ isVisible, switchData, tabId }) => {
  const [btnLoader, setButtonLoader] = useState(false);
  const baseDomain = getBaseDomain();

  const handleRefresh = async () => {
    try {
      setButtonLoader(true);
      const userAuth =
        Cookies.get('accessToken') ||
        localStorage.getItem('auth_token') ||
        sessionStorage.getItem('auth_token');
      const sessionId = Cookies.get('company_session_id');

      if (tabId && userAuth) {
        const url = `https://globalapi.${baseDomain}/api/v1/broadcast/clear/?session_id=${sessionId}&tab_id=${tabId}`;
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${userAuth}`,
            'Content-Type': 'application/json'
          }
        });
        if (!response.ok) {
          console.warn('Failed to clear broadcast messages:', response.status);
        }
      }
    } catch (error) {
      console.error('Error clearing broadcast messages:', error);
    }
    window.location.reload();
    setButtonLoader(false);
  };

  const handleCancel = () => {
    // Modal is not dismissible without refresh
  };

  return (
    <Modal
      title={
        <div className="text-center">
          <h3 className="text-xl font-semibold text-gray-800 mb-0">Tenant Changed</h3>
        </div>
      }
      open={isVisible}
      onCancel={handleCancel}
      footer={null}
      closable={false}
      maskClosable={false}
      keyboard={false}
      centered
      width={500}
      className="tenant-switch-modal"
    >
      <div className="text-center py-6">
        <div className="mb-6">
          <p className="text-gray-700 text-base leading-relaxed">
            Hi <strong>{switchData.user_name}</strong>, You have changed your tenant from{' '}
            <strong>"{switchData.old_company_name}"</strong> to{' '}
            <strong>"{switchData.new_company_name}"</strong>.
          </p>
        </div>

        <Button
          type="primary"
          size="large"
          icon={<ReloadOutlined />}
          onClick={handleRefresh}
          loading={btnLoader}
          className="bg-blue-600 hover:bg-blue-700 border-blue-600 hover:border-blue-700 px-8 py-2 h-12 text-base font-medium"
        >
          Refresh Now
        </Button>
      </div>
    </Modal>
  );
};

export default EnhancedTenantSwitchModal;

